import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessengerService } from '../../messenger/messenger.service';
import { BreadcrumbsService } from '../../shared/components/breadcrumbs/breadcrumbs.service';
import { Auth } from '../auth.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(_auth, _router, _route, _messenger, _breadcrumbs) {
        this._auth = _auth;
        this._router = _router;
        this._route = _route;
        this._messenger = _messenger;
        this._breadcrumbs = _breadcrumbs;
        this.pending = false;
        this.error = false;
        this.msgs = [];
    }
    Object.defineProperty(LoginComponent.prototype, "next", {
        get: function () {
            var next = this._route.snapshot.queryParams['n'];
            return next && decodeURIComponent(next) || '/kezdolap';
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.ngOnInit = function () {
        this.credentials = {
            email: '',
            password: ''
        };
        if (this._auth.isLoggedIn()) {
            this._router.navigate(['/']);
        }
        this._breadcrumbs.setTitle('Bejelentkezés');
    };
    LoginComponent.prototype.ngAfterViewInit = function () {
        this._emailField.nativeElement.focus();
    };
    LoginComponent.prototype.closeAlert = function (alert) {
        var index = this.msgs.indexOf(alert);
        this.msgs.splice(index, 1);
    };
    LoginComponent.prototype.doLogin = function () {
        var _this = this;
        this.error = false;
        if (!this.credentials.email || !this.credentials.password) {
            this.error = true;
            if (!this.credentials.email) {
                this._emailField.nativeElement.focus();
            }
            else {
                this._passwordField.nativeElement.focus();
            }
            return;
        }
        this.pending = true;
        this._auth.doLogin(this.credentials).subscribe(function () { return _this._router.navigateByUrl(_this.next); }, function (e) {
            _this._messenger.handleError(e);
            _this.pending = false;
            _this.msgs[0] = {
                severity: 'danger',
                summary: 'Hiba!',
                details: 'Helytelen belépési adatok!'
            };
            _this._passwordField.nativeElement.focus();
            _this._passwordField.nativeElement.select();
        });
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/login/login.component.ts.pre-build-optimizer.js